import { useState, useEffect } from "react";
import "./App.css";

let alphabet = "abcdefghijklmnopqrstuvwxyz";
let alphabetArray = alphabet.split("");

let uppercaseAlphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
let uppercaseAlphabetArray = uppercaseAlphabet.split("");

let numbers = "0123456789";
let numbersArray = numbers.split("");

let symbolsArray = ["!", "@", "#", "$", "%", "&", "*"];

// App
function App() {
  const [password, setPassword] = useState("");
  const [length, setLength] = useState(10);
  const [upperCaseLetters, setUpperCaseLetters] = useState(false);
  const [lowerCaseLetters, setLowerCaseLetters] = useState(true);
  const [numbers, setNumbers] = useState(true);
  const [symbols, setSymbols] = useState(false);

  let array = [];
  upperCaseLetters && array.push(...uppercaseAlphabetArray);
  lowerCaseLetters && array.push(...alphabetArray);
  numbers && array.push(...numbersArray);
  symbols && array.push(...symbolsArray);

  let newPassword = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.trunc(Math.random() * array.length);
    newPassword += array[randomIndex];
  }

  function handleGeneratePassword() {
    if (!upperCaseLetters && !lowerCaseLetters && !numbers && !symbols) return;
    setPassword(newPassword);
  }

  function handleLangth(event) {
    setLength(event.target.value);
  }

  return (
    <div className="container">
      <h1 className="main-heading">Password Generator</h1>
      <main>
        <GeneratedPassword password={password}>
          {password ? password : "P4$5W0rD!"}
        </GeneratedPassword>
        <div className="box">
          <CharacterLength length={length} onChangeLength={handleLangth}>
            Character Length
          </CharacterLength>
          <ShouldInclude
            checked={upperCaseLetters}
            onChecked={setUpperCaseLetters}
          >
            Include Uppercase Letters
          </ShouldInclude>
          <ShouldInclude
            checked={lowerCaseLetters}
            onChecked={setLowerCaseLetters}
          >
            Include Lowercase Letters
          </ShouldInclude>
          <ShouldInclude checked={numbers} onChecked={setNumbers}>
            Include Numbers
          </ShouldInclude>
          <ShouldInclude checked={symbols} onChecked={setSymbols}>
            Include Symbols
          </ShouldInclude>
          <Strength password={password}>Strength</Strength>
          <GenerateButton onClick={handleGeneratePassword}>
            Generate
          </GenerateButton>
        </div>
      </main>
    </div>
  );
}

function GeneratedPassword({ children, password }) {
  const [isCopied, setIsCopied] = useState(false);

  if (!password && isCopied) {
    setIsCopied(false);
  }

  function handleClipboard() {
    navigator.clipboard.writeText(password);
    setIsCopied(true);
  }

  useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => {
        setIsCopied(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isCopied]);

  return (
    <section className="generated-password">
      <span className={`${password ? "password" : "not-real-password"}`}>
        {children}
      </span>
      <div className="copied-box">
        {isCopied && password && <span className="copied">Copied</span>}
        <div className="clipboard">
          <svg
            onClick={handleClipboard}
            style={{ color: isCopied ? "red" : "" }}
            width="21"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.341 3.091 17.909.659A2.25 2.25 0 0 0 16.319 0H8.25A2.25 2.25 0 0 0 6 2.25V4.5H2.25A2.25 2.25 0 0 0 0 6.75v15A2.25 2.25 0 0 0 2.25 24h10.5A2.25 2.25 0 0 0 15 21.75V19.5h3.75A2.25 2.25 0 0 0 21 17.25V4.682a2.25 2.25 0 0 0-.659-1.591ZM12.469 21.75H2.53a.281.281 0 0 1-.281-.281V7.03a.281.281 0 0 1 .281-.281H6v10.5a2.25 2.25 0 0 0 2.25 2.25h4.5v1.969a.282.282 0 0 1-.281.281Zm6-4.5H8.53a.281.281 0 0 1-.281-.281V2.53a.281.281 0 0 1 .281-.281H13.5v4.125c0 .621.504 1.125 1.125 1.125h4.125v9.469a.282.282 0 0 1-.281.281Zm.281-12h-3v-3h.451c.075 0 .147.03.2.082L18.667 4.6a.283.283 0 0 1 .082.199v.451Z"
              fill="#A4FFAF"
            />
          </svg>
        </div>
      </div>
    </section>
  );
}

function CharacterLength({ children, length, onChangeLength }) {
  return (
    <form className="length-section">
      <div className="length-desc">
        <label className="length-label">{children}</label>
        <span className="length-number">{length}</span>
      </div>
      <input
        className="length-input"
        value={length}
        onChange={onChangeLength}
        type="range"
        min="0"
        max="20"
      />
    </form>
  );
}

function ShouldInclude({ children, checked, onChecked }) {
  return (
    <form className="include-section">
      <label className="include-box">
        <span className="include-label">{children}</span>
        <input
          className="include-checkbox"
          type="checkbox"
          value={checked}
          onChange={() => onChecked((prevState) => !prevState)}
          checked={checked}
        />
        <span className="checkmark"></span>
      </label>
    </form>
  );
}

function Strength({ children, password }) {
  let tooWeek = password !== "" && password.length >= 0 && password.length <= 5;
  let week = password !== "" && password.length >= 6 && password.length <= 10;
  let medium =
    password !== "" && password.length >= 11 && password.length <= 15;
  let strong =
    password !== "" && password.length >= 16 && password.length <= 20;

  let four = password.length > 15 && password.length <= 20;
  let three = password.length > 10 && password.length <= 15;
  let two = password.length > 5 && password.length <= 10;
  let one = password.length > 0 && password.length <= 5;

  console.log(password);
  console.log(one, two, three, four);

  return (
    <div className="strength-section">
      <span className="strength-heading">{children}</span>
      {!one && !two && !three && !four && (
        <div className="strength-bars">
          <div className={`strength-bar`}></div>
          <div className={`strength-bar`}></div>
          <div className={`strength-bar`}></div>
          <div className={`strength-bar`}></div>
        </div>
      )}

      {one && (
        <div className="strength-bars">
          {tooWeek && <span className="strength-text">Too weak!</span>}
          {week && <span className="strength-text">Weak</span>}
          {medium && <span className="strength-text">Medium</span>}
          {strong && <span className="strength-text">Strong</span>}
          <div className={`strength-bar too-weak`}></div>
          <div className={`strength-bar`}></div>
          <div className={`strength-bar`}></div>
          <div className={`strength-bar`}></div>
        </div>
      )}
      {two && (
        <div className="strength-bars">
          {tooWeek && <span className="strength-text">Too weak!</span>}
          {week && <span className="strength-text">Weak</span>}
          {medium && <span className="strength-text">Medium</span>}
          {strong && <span className="strength-text">Strong</span>}
          <div className={`strength-bar weak`}></div>
          <div className={`strength-bar weak`}></div>
          <div className={`strength-bar`}></div>
          <div className={`strength-bar`}></div>
        </div>
      )}
      {three && (
        <div className="strength-bars">
          {tooWeek && <span className="strength-text">Too weak!</span>}
          {week && <span className="strength-text">Weak</span>}
          {medium && <span className="strength-text">Medium</span>}
          {strong && <span className="strength-text">Strong</span>}
          <div className={`strength-bar medium`}></div>
          <div className={`strength-bar medium`}></div>
          <div className={`strength-bar medium`}></div>
          <div className={`strength-bar`}></div>
        </div>
      )}
      {four && (
        <div className="strength-bars">
          {tooWeek && <span className="strength-text">Too weak!</span>}
          {week && <span className="strength-text">Weak</span>}
          {medium && <span className="strength-text">Medium</span>}
          {strong && <span className="strength-text">Strong</span>}
          <div className={`strength-bar strong`}></div>
          <div className={`strength-bar strong`}></div>
          <div className={`strength-bar strong`}></div>
          <div className={`strength-bar strong`}></div>
        </div>
      )}
    </div>
  );
}

function GenerateButton({ children, onClick }) {
  return (
    <button className="generate-button" onClick={onClick}>
      {children}

      <svg
        className="arrow"
        width="12"
        height="12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#a4ffaf"
          d="m5.106 12 6-6-6-6-1.265 1.265 3.841 3.84H.001v1.79h7.681l-3.841 3.84z"
        />
      </svg>
    </button>
  );
}

export default App;
